import { render } from "./send-certificates.vue?vue&type=template&id=c24f135e&scoped=true"
import script from "./send-certificates.vue?vue&type=script&lang=js"
export * from "./send-certificates.vue?vue&type=script&lang=js"

import "./send-certificates.vue?vue&type=style&index=0&id=c24f135e&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c24f135e"]])

export default __exports__